import React from 'react';

import ComposerSubmitButton from './ComposerSubmitButton';

const MultiComposerSubmitButton = props => <ComposerSubmitButton {...props} />;

export default MultiComposerSubmitButton;
